angular.module('mychart')
    .factory('PatientAttachmentRepository', ['AprimaRestangular', 'AprimaAnalytics', function (aprimaRestangular, AprimaAnalytics) {
        'use strict';

        var getAttachment = function (attachmentId, patientId, requestSettings, applicationComponent, disableInLinePdf) {
            var timing = AprimaAnalytics.startTiming(applicationComponent || 'AttachmentRepository', 'api', 'getAttachment');
            var inlinePDF = (disableInLinePdf) ? false : true;
        	var queryString = '?page=' + requestSettings.page + '&height=' + requestSettings.height + '&width=' + requestSettings.width + '&inLinePDF=' + inlinePDF;

            return aprimaRestangular.get('patient').one('patients/' + patientId +'/attachments/' + attachmentId + queryString).get().finally(timing.stop);
        };

        var getAttachmentStaticUrl = function (attachmentId, patientId, applicationComponent) {
            var timing = AprimaAnalytics.startTiming(applicationComponent || 'AttachmentRepository', 'api', 'getAttachmentStaticUrl');

            return aprimaRestangular.get('patient').one('patients/' + patientId +'/attachments-url/' + attachmentId).get().finally(timing.stop);
        };

        var getAttachmentRetainOriginalFormat = function (attachmentId, patientId, applicationComponent) {
            var timing = AprimaAnalytics.startTiming(applicationComponent || 'AttachmentRepository', 'api', 'getAttachmentRetainOriginalFormat');
            var queryString = '?retainoriginalformat=true';
            return aprimaRestangular.get('patient').one('patients/' + patientId +'/attachments/' + attachmentId + queryString).get().finally(timing.stop);
        };

        return {
            getAttachment: getAttachment,
            getAttachmentStaticUrl: getAttachmentStaticUrl,
            getAttachmentRetainOriginalFormat: getAttachmentRetainOriginalFormat
        };

    }]);
